export default "__VITE_ASSET__CnmC9_BW__"